import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-sidebar-sale',
  templateUrl: './menu-sidebar-sale.component.html',
  styleUrls: ['./menu-sidebar-sale.component.scss']
})
export class MenuSidebarSaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
